import React, { useState, useEffect } from 'react';
import moment from 'moment';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { timeLimitAmtStatistics } from 'lib/api/time';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import Popover from 'components/molecules/Popover';
import CategoryFilter from 'components/organisms/CategoryFilter';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {
  sDate: moment().format('YYYYMMDD'),
};
const weekFlagList = [
  {
    label: i18next.t('전체'),
    value: '00',
  },
  {
    label: i18next.t('평일'),
    value: '01',
  },
  {
    label: i18next.t('주말'),
    value: '02',
  },
];
let closePopover = null;

const LimitStatistics = () => {
  const { t } = useTranslation();

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  const [weekFlag, setWeekFlag] = useState('00');

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return {
          content: <>{getHeadObj(headsMap, 'ADVRTS_AMT').label}(쇼핑)</>,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVRTS_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <span className={'black'}>
              (
              {makeRowColumn(
                rowObj['TRGT_ADVRTS_AMT'],
                bodyItem2.type,
                bodyItem2.format
              )}
              )
            </span>
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'MOB_SESSION_ROAS').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'MOB_SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const mobSessionRoas = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
        const trgtMobSessionRoas = getHeadObj(
          headsMap,
          'TRGT_MOB_SESSION_ROAS'
        );
        const mobSessionOrderAmt = getHeadObj(
          headsMap,
          'MOB_SESSION_ORDER_AMT'
        );
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['MOB_SESSION_ROAS'],
              mobSessionRoas.type,
              mobSessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ROAS'],
              trgtMobSessionRoas.type,
              trgtMobSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['MOB_SESSION_ORDER_AMT'],
              mobSessionOrderAmt.type,
              mobSessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_MOB_SESSION_ROAS: {
      merged: true,
    },
    MOB_SESSION_ORDER_AMT: {
      merged: true,
    },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'SESSION_ORDER_AMT').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const sessionRoas = getHeadObj(headsMap, 'SESSION_ROAS');
        const trgtSessionRoas = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const sessionOrderAmt = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['SESSION_ROAS'],
              sessionRoas.type,
              sessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_SESSION_ROAS'],
              trgtSessionRoas.type,
              trgtSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              sessionOrderAmt.type,
              sessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_SESSION_ROAS: {
      merged: true,
    },
    SESSION_ORDER_AMT: {
      merged: true,
    },
    DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label +
                '(' +
                t('쇼핑') +
                ')'
              }
              tooltipType={'DIRECT_ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const directRoas = getHeadObj(headsMap, 'DIRECT_ROAS');
        const trgtDirectRoas = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const directOrderAmt = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['DIRECT_ROAS'],
              directRoas.type,
              directRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_DIRECT_ROAS'],
              trgtDirectRoas.type,
              trgtDirectRoas.format
            )}
            item3={makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              directOrderAmt.type,
              directOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_DIRECT_ROAS: {
      merged: true,
    },
    DIRECT_ORDER_AMT: {
      merged: true,
    },
    ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'ORDER_AMT').label + '(' + t('쇼핑') + ')'
              }
              tooltipType={'ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const roas = getHeadObj(headsMap, 'ROAS');
        const trgtRoas = getHeadObj(headsMap, 'TRGT_ROAS');
        const orderAmt = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ROAS'], roas.type, roas.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ROAS'],
              trgtRoas.type,
              trgtRoas.format
            )}
            item3={makeRowColumn(
              rowObj['ORDER_AMT'],
              orderAmt.type,
              orderAmt.format
            )}
          />
        );
      },
    },
    TRGT_ROAS: {
      merged: true,
    },
    ORDER_AMT: {
      merged: true,
    },
    ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'ECPM').label + '(' + t('쇼핑') + ')'}
              tooltipType={'ECPM'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const ecpm = getHeadObj(headsMap, 'ECPM');
        const trgtEcpm = getHeadObj(headsMap, 'TRGT_ECPM');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ECPM'], ecpm.type, ecpm.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ECPM'],
              trgtEcpm.type,
              trgtEcpm.format
            )}
          />
        );
      },
    },
    TRGT_ECPM: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  const getOnClose = (handleClose) => {
    closePopover = handleClose;
  };

  /**
   * 요일구분
   * @param {object} e
   */
  const handleOnCode = (e) => {
    const { value } = e.target;
    const newParams = {
      ...params,
    };

    if (value !== '00') {
      newParams[e.target.name] = value;
    } else {
      newParams[e.target.name] = null;
    }

    closePopover();
    setWeekFlag(value);
    setParams(newParams);
  };

  /**
   * 필터 선택 관련
   */
  const handleOnchangeFilter = (filterParam) => {
    setParams({ ...params, ...filterParam });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          initData={initParam}
          getParam={getParam}
          useTimeFilter={{ used: true, useRange: true }}
        />
        <Popover
          name="weekFlag"
          label={t('요일구분')}
          getOnClose={getOnClose}
          selectedLabel={t(
            weekFlag === '00' ? '전체' : weekFlag === '01' ? '평일' : '주말'
          )}
          filtered={weekFlag !== '00'}
          filterType="radio"
          optionSelectedValue={weekFlag}
          optionList={weekFlagList}
          optionOnChange={handleOnCode}
        />
        <CategoryFilter
          initialization={initialization}
          handleOnchangeFilter={handleOnchangeFilter}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={timeLimitAmtStatistics}
            params={{ ...params }}
            sort="desc"
            order="STATS_HH"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
            noneSearch
          />
        </>
      )}
    </>
  );
};

export default LimitStatistics;
